import { ENTRY_POINT } from '@/types/entryPoints';

// 将url中的from转为后端需要的格式
/**
 * @returns {ENTRY_POINT}
 */
export const formatFromInUrl = (from: any) => {
  const isGeneral = !from || !ENTRY_POINT[from];
  if (isGeneral) {
    return ENTRY_POINT.general;
  }

  return ENTRY_POINT[from];
};

// 将 url 中的 from 填充默认值
/**
 * @returns {ENTRY_POINT}
 */
export const formatFromInUrlToEntrypointName = (from: any) => {
  const isGeneral = !from;

  // 因为livechat 已这样上线，需要先这样兼容，后续需要改
  const TempBankEntryPointMap = {
    BankHelpCenter: 'BankPHHelpCenter',
    BankMePage: 'BankPHMepage',
    BankSGMePage: 'BankSGMepage',
  } as any;

  if (isGeneral) {
    return ENTRY_POINT[ENTRY_POINT.general];
  }

  if (Object.keys(TempBankEntryPointMap).includes(from)) {
    return TempBankEntryPointMap[from];
  }

  return from;
};


export const getQueryForm = (name: string, searchUrl: string) => {
  const urlSearchParams = new URLSearchParams(searchUrl || window.location.search);

  return urlSearchParams.get(name) || '';
};

export const getScrollElement = () => {
  return document.getElementById('global-scroll');
};

export const getShortCutElement = () => {
  return document.getElementById('shortcuts-container');
};

export const getNavbarHeight = () => {
  return document.getElementsByClassName('custom-navbar')?.[0]?.clientHeight || 0;
};

export const mktBridgeCallHandler = async (name = '', params = {}) => {
  return new Promise((resolve) => {
    try {
      window.bridgeCallHandler(name, params, (data: any) => {
        resolve(data);
      });
    } catch (err) {
      // @ts-ignore
      console.error(err.message);
      resolve({});
    }
  });
};

export const addData = (dataList: any[], data: any, id: string) => {
  // 一开始渲染的时候, 先有了id，但是还没把数据放入到data，跳过此时的状态
  if (data[id] === undefined) {
    return dataList;
  }

  const dataItem = data[id].slice();
  dataList = dataList.concat(dataItem);
  return dataList;
};

// 截流函数
export const throttle = (func: any, delay: number, needRemain = true) => {
  // @ts-ignore
  let timer: NodeJS.Timeout | null = null;
  let startTime = Date.now();
  return function (...args: any[]) {
    const curTime = Date.now();
    const remaining = delay - (curTime - startTime);
    // @ts-ignore
    const context = this;
    clearTimeout(timer as any);
    if (remaining <= 0) {
      func.apply(context, args);
      startTime = Date.now();
    } else if (needRemain) {
      timer = setTimeout(func, remaining);
    }
  };
};
